export function isArray(value) {
    return Array.isArray(value);
}
export function isFunction(fun) {
    return typeof fun === 'function';
}
export function isNil(value) {
    return value === undefined || value === null;
}
export function isString(value) {
    return typeof value === 'string';
}
//# sourceMappingURL=utils.js.map